@switch (question.entryType) {
  @case ('textBlock') {
    <dt-questionnaire-question-textblock [entry]="$any(question)"></dt-questionnaire-question-textblock>
  }
  @case ('optionsQuestion') {
    <dt-questionnaire-question-options [entry]="$any(question)" [formIndex]="formIndex"></dt-questionnaire-question-options>
  }
  @case ('numberQuestion') {
    <dt-questionnaire-question-number [entry]="$any(question)" [formIndex]="formIndex"></dt-questionnaire-question-number>
  }
  @case ('textQuestion') {
    <dt-questionnaire-question-text [entry]="$any(question)" [formIndex]="formIndex"></dt-questionnaire-question-text>
  }
  @case ('tableQuestion') {
    <dt-questionnaire-question-table [entry]="$any(question)" [formIndex]="formIndex"></dt-questionnaire-question-table>
  }
}
